import React from 'react';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { CheckCircleFill, LightningChargeFill, StarFill, GraphUpArrow, GearFill, ChatDotsFill, Link45deg } from 'react-bootstrap-icons';

const ProFeatures = ({ isPro }) => {
  const features = [
    {
      title: 'Unlimited Affiliate Links',
      description: 'Create unlimited affiliate links for your campaigns vs. only 3 on the free plan',
      available: true,
      icon: <Link45deg size={20} className="text-warning" />,
      highlight: true
    },
    {
      title: 'Unlimited Clicks',
      description: 'Track unlimited clicks per month with no usage caps',
      available: true,
      icon: <LightningChargeFill size={20} className="text-primary" />
    },
    {
      title: 'Unlimited Conversions',
      description: 'Record unlimited conversions per month with no usage caps',
      available: true,
      icon: <GraphUpArrow size={20} className="text-success" />
    },
    {
      title: 'Advanced Dashboard',
      description: 'Access to detailed performance metrics and real-time campaign insights',
      available: true,
      icon: <GearFill size={20} className="text-secondary" />
    },
    {
      title: 'Export Data',
      description: 'Export your tracking data and analytics in various formats',
      available: true,
      icon: <StarFill size={20} className="text-info" />
    },
    {
      title: 'Priority Support',
      description: 'Get priority email support from our dedicated team',
      available: true,
      icon: <ChatDotsFill size={20} className="text-danger" />
    }
  ];

  return (
    <Card className="shadow-sm border-0 mb-4">
      <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          <StarFill className="me-2 text-warning" />
          {isPro ? 'Your Pro Benefits' : 'Pro Plan Benefits'}
        </h5>
        {isPro && <Badge bg="success" pill className="px-3 py-2">ACTIVE</Badge>}
      </Card.Header>
      
      <ListGroup variant="flush">
        {features.map((feature, index) => (
          <ListGroup.Item 
            key={index} 
            className={`d-flex align-items-start py-3 ${feature.highlight ? 'bg-light' : ''} ${isPro ? '' : 'text-muted'}`}
          >
            <div className="me-3 mt-1">
              {isPro ? (
                feature.icon || <CheckCircleFill className="text-success" size={20} />
              ) : (
                feature.icon || <CheckCircleFill className="text-secondary opacity-50" size={20} />
              )}
            </div>
            <div>
              <div className="d-flex align-items-center mb-1">
                <h6 className="mb-0">{feature.title}</h6>
                {feature.highlight && <Badge bg="warning" text="dark" className="ms-2 px-2 py-1" style={{fontSize: '0.7rem'}}>POPULAR</Badge>}
              </div>
              <p className="mb-0 small">{feature.description}</p>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card>
  );
};

export default ProFeatures;
